import React, {useEffect, useState} from 'react'
import {IEnterprises, enterprisesInitValues as initialValues} from '../../models/EnterprisesModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import {useLocation} from 'react-router-dom'
import Swal from 'sweetalert2'
//import withReactContent from 'sweetalert2-react-content'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
//import Map from '@arcgis/core/Map'
//import MapView from '@arcgis/core//views/MapView'
import makeAnimated from 'react-select/animated'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {MultiSelect} from 'primereact/multiselect'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {MapEditEnterprise} from './MapEditEnterprise'
import {Dropdown} from 'primereact/dropdown'
import {Calendar} from 'primereact/calendar'
import moment from 'moment'
import {insertDataTime} from '../../../../../../util/insertDataTime'

export interface UseOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

//import {useToast} from '../../../../../../app/layout/hooks/toast'
const API_URL = process.env.REACT_APP_API_URL || 'api'

const enterprisesSchema = Yup.object().shape({
  // name: Yup.string().required('Campo obrigatório'),
  // document: Yup.string().required('Campo obrigatório'),
  // number: Yup.number().required('Campo obrigatório').positive().integer(),
  // telephone: Yup.string().required('Campo obrigatório'),
  // email: Yup.string().email().required('Campo obrigatório'),
})

const FormEnterprisesEdit: React.FC = () => {
  const intl = useIntl()
  const location = useLocation()
  // const MySwal = withReactContent(Swal)
  const navigate = useNavigate()
  //const [uuid, setUuid] = useState('')
  const animatedComponents = makeAnimated()
  const [latitude, setLatitude] = useState(0)
  const [longitude, setLongitude] = useState(0)
  const [geom_point, setGeomPoint] = useState(0)
  const [geom_line, setGeomLine] = useState(0)
  const [geom_polygon, setGeomPolygon] = useState(0)
  const [type_geometry, setTypeGeometry] = useState(0)

  const [loading, setLoading] = useState(false)

  //Tipo de Empreendimento
  const [selectedEnterpriseType, setSelectedEnterpriseType] = useState(null)
  const [enterpriseTypes, setEnterpriseTypes] = useState([])

  //Empreendedores
  const [selectedEntrepreneur, setSelectedEntrepreneur] = useState(null)
  const [entrepreneurs, setEntrepreneurs] = useState([])

  //Projetos
  const [selectedProject, setSelectedProject] = useState(null)
  const [getProjects, setProjects] = useState([])

  //Unidade/Setor
  const [selectedField, setSelectedField] = useState(null)
  const [getFields, setFields] = useState([])

  //DATA DE IMPLANTACAO
  const [selectedImplantationDate, setSelectedImplantationDate] = useState()
  const [getImplantationDate, setImplantationDate] = useState<Date | undefined>()

  //UNIDADE DE MEDIDA
  const [selectedMeasurementUnit, setSelectedMeasurementUnit] = useState(null)
  const [measurementUnits, setMeasurementUnit] = useState([])

  const {uuid, enterprise_type_id, entrepreneur_id, projects, fields, measurement_unit_id} =
    location.state as IEnterprises

  useEffect(() => {
    if (location) {
      //setUuid(uuid || '')
      if (uuid) {
        getEnterprise(uuid)
      }
    }
    loadOptionsEnterpriseTypes()
    loadOptionsEntrepreneurs()
    loadOptionsProjects()
    loadOptionsFields()
    loadOptionsMeasurementUnits()
  }, [])

  async function getEnterprise(uuid: string) {
    const {data} = await axios.get(API_URL + '/v1/enterprises/' + uuid)
    const Enterprises: IEnterprises = data.data

    if (Enterprises.uuid) {
      formik.setFieldValue('uuid', Enterprises.uuid)
    }
    if (Enterprises.description) {
      formik.setFieldValue('description', Enterprises.description)
    }
    if (Enterprises.name) {
      formik.setFieldValue('name', Enterprises.name)
    }

    if (Enterprises.regulatory_name) {
      formik.setFieldValue('regulatory_name', Enterprises.regulatory_name)
    }
    if (Enterprises.size) {
      formik.setFieldValue('size', Enterprises.size)
    }

    if (Enterprises.occuped_area_size) {
      formik.setFieldValue('occuped_area_size', Enterprises.occuped_area_size)
    }

    if (Enterprises.city) {
      formik.setFieldValue('city', Enterprises.city)
    }

    if (Enterprises.uf) {
      formik.setFieldValue('uf', Enterprises.uf)
    }
    if (Enterprises.latitude) {
      formik.setFieldValue('latitude', Enterprises.latitude)
      setLatitude(Enterprises.latitude)
    }
    if (Enterprises.longitude) {
      formik.setFieldValue('longitude', Enterprises.longitude)
      setLongitude(Enterprises.longitude)
    }
    if (Enterprises.geom_point) {
      formik.setFieldValue('geom_point', Enterprises.geom_point)
      setGeomPoint(Enterprises.geom_point as any)
    }
    if (Enterprises.geom_line) {
      formik.setFieldValue('geom_line', Enterprises.geom_line)
      setGeomLine(Enterprises.geom_line as any)
    }
    if (Enterprises.geom_polygon) {
      formik.setFieldValue('geom_polygon', Enterprises.geom_polygon)
      setGeomPolygon(Enterprises.geom_polygon as any)
    }
    if (Enterprises.type_geometry) {
      formik.setFieldValue('type_geometry', Enterprises.type_geometry)
      setTypeGeometry(Enterprises.type_geometry as any)
    }

    if (Enterprises.enterprise_type_id) {
      formik.setFieldValue('enterprise_type_id', Enterprises.enterprise_type_id)
    }

    if (Enterprises.entrepreneur_id) {
      formik.setFieldValue('entrepreneur_id', Enterprises.entrepreneur_id)
    }
    if (Enterprises.implantation_date) {
      formik.setFieldValue('implantation_date', Enterprises.implantation_date)
      setImplantationDate(new Date(`${Enterprises.implantation_date} 12:00:00`))
    }

    return data
  }

  //eslint-disable-next-line
  const formik = useFormik<IEnterprises>({
    initialValues,
    validationSchema: enterprisesSchema,
    onSubmit: async (values) => {
      setLoading(true)

      values.geom_point = null
      values.geom_line = null
      values.geom_polygon = null
      values.type_geometry = null

      if (geom_point !== null && geom_point !== 0) {
        values.geom_point = '' + geom_point
      }
      if (geom_line !== null && geom_line !== 0) {
        values.geom_line = '' + geom_line
      }
      if (geom_polygon !== null && geom_polygon !== 0) {
        values.geom_polygon = '' + geom_polygon
      }
      if (type_geometry !== null && type_geometry !== 0) {
        values.type_geometry = '' + type_geometry
      }

      try {
        await axios.put(API_URL + '/v1/enterprises/' + values.uuid, values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'ENTERPRISE.SWAL_EDIT'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/enterprises')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'ENTERPRISE.SWAL_EDIT_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
      }
    },
  })

  function resetInputs() {
    setSelectedEnterpriseType(null)
    setSelectedEntrepreneur(null)
    setSelectedMeasurementUnit(null)
    setSelectedProject(null)
    setSelectedField(null)
    formik.resetForm()
  }

  /*---------------------- INICIO TIPO EMPREEDIMENTO OPTIONS ----------------------*/
  const loadOptionsEnterpriseTypes = () => {
    setTimeout(() => {
      getEnterpriseTypes()
      let enterprise_types: any = []
      let option_enterprise_type: any = []

      async function getEnterpriseTypes() {
        const {data} = await axios.get(API_URL + '/v1/enterprise_types/select2')
        let Response = data.results

        for (const element of Response) {
          const enterprise_type: any = {
            code: element.id,
            name: element.name,
          }

          enterprise_types.push(enterprise_type)

          if (enterprise_type_id === element.id) {
            option_enterprise_type.push(enterprise_type)
          }
        }
        setSelectedEnterpriseType(option_enterprise_type[0])
      }

      setEnterpriseTypes(enterprise_types)

      return enterprise_types
    }, 1000)
  }
  /*---------------------- FIM TIPO EMPREEDIMENTO OPTIONS ----------------------*/

  /*---------------------- INICIO EMPREENDEDORES OPTIONS ----------------------*/
  const loadOptionsEntrepreneurs = () => {
    setTimeout(() => {
      getEntrepreneurs()
      let entrepreneurs: any = []
      let option_entrepreneur: any = []

      async function getEntrepreneurs() {
        const {data} = await axios.get(API_URL + '/v1/entrepreneurs/select2')
        let Response = data.results

        for (const element of Response) {
          const entrepreneur: any = {
            code: element.id,
            name: element.name,
          }

          entrepreneurs.push(entrepreneur)

          if (entrepreneur_id === element.id) {
            option_entrepreneur.push(entrepreneur)
          }
        }
        setSelectedEntrepreneur(option_entrepreneur[0])
      }

      setEntrepreneurs(entrepreneurs)

      return entrepreneurs
    }, 1000)
  }
  /*---------------------- FIM EMPREENDEDORES OPTIONS ----------------------*/

  /*---------------------- INICIO PROJETOS OPTIONS ----------------------*/
  const loadOptionsProjects = () => {
    setTimeout(() => {
      getProjects()
      let array_projects: any = []
      let option_project: any = []

      let initial_project_id: any = []

      projects?.map((project: any) => {
        return initial_project_id.push(project.id)
      })

      async function getProjects() {
        const {data} = await axios.get(API_URL + '/v1/projects/select2')
        let Response = data.results

        for (const element of Response) {
          const project: any = {
            code: element.id,
            name: `${element.code} - ${element.description}`,
          }

          array_projects.push(project)

          if (projects) {
            for (let j = 0; j < projects?.length; j++) {
              if (projects[j].id === element.id) {
                option_project.push(project)
              }
              setSelectedProject(option_project)
            }
          }
        }
      }

      setProjects(array_projects)
      formik.setFieldValue('project_id', initial_project_id)

      return array_projects
    }, 1000)
  }
  /*---------------------- FIM PROJETOS OPTIONS ----------------------*/

  /*---------------------- INICIO UNIDADE/SETOR OPTIONS ----------------------*/
  const loadOptionsFields = () => {
    setTimeout(() => {
      getFields()
      let array_fields: any = []
      let option_field: any = []

      let initial_field_id: any = []

      fields?.map((field: any) => {
        return initial_field_id.push(field.id)
      })

      async function getFields() {
        const {data} = await axios.get(API_URL + '/v1/fields/select2')
        let Response = data.results

        for (const element of Response) {
          const field: any = {
            code: element.id,
            name: `${element.abbreviate} - ${element.name}`,
          }

          array_fields.push(field)

          if (fields) {
            for (let j = 0; j < fields?.length; j++) {
              if (fields[j].id === element.id) {
                option_field.push(field)
              }
              setSelectedField(option_field)
            }
          }
        }
      }

      setFields(array_fields)
      formik.setFieldValue('field_id', initial_field_id)

      return array_fields
    }, 1000)
  }
  /*---------------------- FIM UNIDADE/SETOR OPTIONS ----------------------*/

  /*---------------------- INICIO UNIDADE DE MEDIDA OPTIONS ----------------------*/
  const loadOptionsMeasurementUnits = () => {
    setTimeout(() => {
      getMeasurementUnits()
      let measurement_units: any = []
      let option_measurement_unit: any = []

      async function getMeasurementUnits() {
        const {data} = await axios.get(API_URL + '/v1/measurement_units/select2?type=area')
        let Response = data.results

        for (const element of Response) {
          const measurement_unit: any = {
            code: element.id,
            name: `${element.abbreviation} - ${element.description}`,
          }

          measurement_units.push(measurement_unit)

          if (measurement_unit_id === element.id) {
            option_measurement_unit.push(measurement_unit)
          }
        }
        setSelectedMeasurementUnit(option_measurement_unit[0])
      }

      setMeasurementUnit(measurement_units)

      return measurement_units
    }, 1000)
  }
  /*---------------------- FIM UNIDADE DE MEDIDA OPTIONS ----------------------*/

  /*---------------------- INICIO DATA DE IMPLANTAÇÃO ----------------------*/
  const setConvertDate = (e: any, typeDate: 'implantation_date') => {
    let DateFormate: any
    switch (typeDate) {
      case 'implantation_date': {
        DateFormate = moment(new Date(e)).format('YYYY-MM-DD')

        setImplantationDate(e)
        setSelectedImplantationDate(DateFormate)
        break
      }
    }
  }
  insertDataTime()
  /*---------------------- FIM DATA DE IMPLANTAÇÃO ----------------------*/
  return (
    <div className='card card-custom mt-n8 pb-0'>
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'ENTERPRISE.TITLE_EDIT'})}</PageTitle>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='col-lg-7'>
                  <div className='row mb-3'>
                    {/*---------------------- INICIO NOME ----------------------*/}
                    <div className='col-lg-6'>
                      <label className='col-form-label required fw-bold '>
                        {intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
                      </label>

                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_NAME_PLACEHOLDER'})}
                        {...formik.getFieldProps('name')}
                      />
                      {formik.touched.name && formik.errors.name && (
                        <div className='fv-plugins-message-container text-danger'>
                          <div className='fv-help-block'>{formik.errors.name}</div>
                        </div>
                      )}
                    </div>
                    {/*---------------------- FIM NOME ----------------------*/}

                    {/*---------------------- INICIO TIPO EMPREEDIMENTO ----------------------*/}
                    <div className='col-lg-6'>
                      <label className='required col-form-label fw-bold '>
                        {intl.formatMessage({id: 'ENTERPRISE_TYPE.ENTERPRISE_TYPE_SINGLE'})}
                      </label>
                      <Dropdown
                        className='form-control form-control-sm form-control-solid p-0 ps-3 border border-white'
                        value={selectedEnterpriseType}
                        options={enterpriseTypes}
                        onChange={(e: any) => {
                          e.target.value !== undefined
                            ? formik.setFieldValue('enterprise_type_id', e.target.value.code)
                            : formik.setFieldValue('enterprise_type_id', undefined)

                          setSelectedEnterpriseType(e.value)
                        }}
                        style={{
                          fontFamily: 'Poppins',
                          fontSize: '1.15rem',
                          fontWeight: 'medium',
                        }}
                        optionLabel='name'
                        showClear
                        filter
                        placeholder={intl.formatMessage({id: 'ENTERPRISE_TYPE.SELECT_PLACEHOLDER'})}
                      />
                    </div>
                    {/*---------------------- FIM TIPO EMPREEDIMENTO ----------------------*/}
                  </div>

                  <div className='row mb-3'>
                    {/*---------------------- INICIO EMPREENDEDORES ----------------------*/}
                    <div className='col-lg-12'>
                      <label className='required col-form-label fw-bold '>
                        {intl.formatMessage({id: 'ENTREPRENEUR.ENTREPRENEUR_SINGLE'})}
                      </label>

                      <Dropdown
                        className='form-control form-control-sm form-control-solid p-0 ps-3 border border-white'
                        value={selectedEntrepreneur}
                        options={entrepreneurs}
                        onChange={(e: any) => {
                          e.target.value !== undefined
                            ? formik.setFieldValue('entrepreneur_id', e.target.value.code)
                            : formik.setFieldValue('entrepreneur_id', undefined)

                          setSelectedEntrepreneur(e.value)
                        }}
                        style={{
                          fontFamily: 'Poppins',
                          fontSize: '1.15rem',
                          fontWeight: 'medium',
                        }}
                        optionLabel='name'
                        showClear
                        filter
                        placeholder={intl.formatMessage({id: 'ENTREPRENEUR.SELECT_PLACEHOLDER'})}
                      />
                    </div>
                    {/*---------------------- FIM EMPREENDEDORES ----------------------*/}

                    {/*---------------------- INICIO PROJETOS ----------------------*/}
                    <div className='col-lg-12'>
                      <label className='required col-form-label fw-bold '>
                        {intl.formatMessage({id: 'PROJECT.PROJECT_PLURAL'})}
                      </label>
                      <MultiSelect
                        className='form-control form-control-sm form-control-solid p-0 ps-3 border border-white'
                        value={selectedProject}
                        options={getProjects}
                        showClear
                        onChange={(e: any) => {
                          e.value !== null
                            ? formik.setFieldValue(
                                'project_id',
                                e.value.map((v: any) => {
                                  return v.code
                                })
                              )
                            : formik.setFieldValue('project_id', undefined)
                          setSelectedProject(e.value)
                        }}
                        placeholder={intl.formatMessage({id: 'SELECT.INPUT_SGA_USER'})}
                        optionLabel='name'
                        filter
                        display='chip'
                      />
                    </div>
                    {/*---------------------- FIM PROJETOS ----------------------*/}
                  </div>

                  {/*---------------------- INICIO UNIDADE/SETOR ----------------------*/}
                  <div className='col-lg-12'>
                    <label className='col-form-label required fw-bold '>
                      {intl.formatMessage({id: 'FIELD.FIELD_PLURAL'})}
                    </label>
                    <MultiSelect
                      className='form-control form-control-sm form-control-solid p-0 ps-3 border border-white'
                      value={selectedField}
                      options={getFields}
                      showClear
                      onChange={(e: any) => {
                        e.value !== null
                          ? formik.setFieldValue(
                              'field_id',
                              e.value.map((v: any) => {
                                return v.code
                              })
                            )
                          : formik.setFieldValue('field_id', undefined)
                        setSelectedField(e.value)
                      }}
                      placeholder={intl.formatMessage({id: 'FIELD.SELECT_PLACEHOLDER'})}
                      optionLabel='name'
                      filter
                      display='chip'
                    />
                  </div>
                  {/*---------------------- FIM UNIDADE / SETOR ----------------------*/}

                  <div className='row mb-3'>
                    {/*---------------------- INICIO ATIVO ----------------------*/}
                    <div className='col-lg-8'>
                      <label className='col-lg-4 col-form-label fw-bold '>
                        {intl.formatMessage({id: 'ENTERPRISE.INPUT_REGULATORY_NAME'})}
                      </label>

                      <input
                        type='TEXT'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder={intl.formatMessage({
                          id: 'ENTERPRISE.INPUT_REGULATORY_NAME_PLACEHOLDER',
                        })}
                        {...formik.getFieldProps('regulatory_name')}
                      />
                      {formik.touched.regulatory_name && formik.errors.regulatory_name && (
                        <div className='fv-plugins-message-container text-danger'>
                          <div className='fv-help-block'>{formik.errors.regulatory_name}</div>
                        </div>
                      )}
                    </div>
                    {/*---------------------- FIM ATIVO ----------------------*/}

                    {/*---------------------- INICIO COMPRIMENTO ----------------------*/}
                    <div className='col-lg-4'>
                      <label className='col-form-label fw-bold '>
                        {intl.formatMessage({id: 'COMMON.INPUT_SIZE'})}
                      </label>

                      <input
                        type='number'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_SIZE_PLACEHOLDER'})}
                        {...formik.getFieldProps('size')}
                      />
                    </div>
                    {/*---------------------- FIM COMPRIMENTO ----------------------*/}
                  </div>
                  <div className='row mb-3'>
                    {/*---------------------- INICIO DATA DE IMPLANTACAO ----------------------*/}
                    <div className='col-lg-5'>
                      <label className='col-form-label fw-bold '>
                        {intl.formatMessage({id: 'COMMON.INPUT_IMPLANTATION_DATE'})}
                      </label>

                      <Calendar
                        value={getImplantationDate}
                        onChange={(e: any) => setConvertDate(e.value, 'implantation_date')}
                        selectionMode='single'
                        inputClassName='form-control form-control-solid ps-6 fw-bold border-white'
                        style={{
                          width: '100%',
                        }}
                        dateFormat='dd/mm/yy'
                        placeholder='dd/mm/aaaa'
                        showButtonBar
                      />
                    </div>
                    {/*---------------------- INICIO DATA DE IMPLANTACAO ----------------------*/}

                    {/*---------------------- INICIO UNIDADE DE MEDIDA ----------------------*/}
                    <div className='col-lg-4'>
                      <label className='col-form-label fw-bold '>
                        {intl.formatMessage({id: 'COMMON.INPUT_UNIT_OCCUPED_AREA'})}
                      </label>

                      <Dropdown
                        className='form-control form-control-sm form-control-solid p-0 ps-3 border border-white'
                        value={selectedMeasurementUnit}
                        options={measurementUnits}
                        onChange={(e: any) => {
                          e.target.value !== undefined
                            ? formik.setFieldValue('measurement_unit_id', e.target.value.code)
                            : formik.setFieldValue('measurement_unit_id', undefined)

                          setSelectedMeasurementUnit(e.value)
                        }}
                        style={{
                          fontFamily: 'Poppins',
                          fontSize: '1.15rem',
                          fontWeight: 'medium',
                        }}
                        optionLabel='name'
                        showClear
                        filter
                        placeholder={intl.formatMessage({
                          id: 'COMMON.SELECT_UNIT_OCCUPED_AREA_PLACEHOLDER',
                        })}
                      />
                    </div>
                    {/*---------------------- FIM UNIDADE DE MEDIDA ----------------------*/}

                    {/*---------------------- INICIO TAMANHO DA AREA OCUPADA ----------------------*/}
                    <div className='col-lg-3'>
                      <label className='col-form-label fw-bold '>
                        {intl.formatMessage({id: 'COMMON.INPUT_OCCUPED_AREA'})}
                      </label>

                      <input
                        type='number'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder={intl.formatMessage({
                          id: 'COMMON.INPUT_OCCUPED_AREA_PLACEHOLDER',
                        })}
                        {...formik.getFieldProps('occuped_area_size')}
                      />
                    </div>
                    {/*---------------------- FIM TAMANHO DA AREA OCUPADA ----------------------*/}
                  </div>

                  <div className='row mb-3'>
                    {/*---------------------- INICIO CIDADE ----------------------*/}
                    <div className='col-lg-6'>
                      <label className='col-form-label fw-bold '>
                        {intl.formatMessage({id: 'COMMON.INPUT_CITY'})}
                      </label>

                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder={intl.formatMessage({id: 'COMMON.INPUT_CITY_PLACEHOLDER'})}
                        {...formik.getFieldProps('city')}
                      />
                    </div>
                    {/*---------------------- FIM CIDADE ----------------------*/}

                    {/*---------------------- INICIO ESTADO ----------------------*/}
                    <div className='col-lg-6'>
                      <label className='col-form-label required fw-bold '>
                        {intl.formatMessage({id: 'COMMON.INPUT_STATE'})}
                      </label>

                      <select
                        className='form-select form-select-solid fw-bold'
                        {...formik.getFieldProps('uf')}
                      >
                        <option value=''>
                          {intl.formatMessage({id: 'COMMON.INPUT_STATE_MSG'})}
                        </option>
                        <option value='AC'>Acre</option>
                        <option value='AL'>Alagoas</option>
                        <option value='AP'>Amapá</option>
                        <option value='AM'>Amazonas</option>
                        <option value='BA'>Bahia</option>
                        <option value='CE'>Ceará</option>
                        <option value='DF'>Distrito Federal</option>
                        <option value='ES'>Espírito Santo</option>
                        <option value='GO'>Goiás</option>
                        <option value='MA'>Maranhão</option>
                        <option value='MT'>Mato Grosso</option>
                        <option value='MS'>Mato Grosso do Sul</option>
                        <option value='MG'>Minas Gerais</option>
                        <option value='PA'>Pará</option>
                        <option value='PB'>Paraíba</option>
                        <option value='PR'>Paraná</option>
                        <option value='PE'>Pernambuco</option>
                        <option value='PI'>Piauí</option>
                        <option value='RJ'>Rio de Janeiro</option>
                        <option value='RN'>Rio Grande do Norte</option>
                        <option value='RS'>Rio Grande do Sul</option>
                        <option value='RO'>Rondônia</option>
                        <option value='RR'>Roraima</option>
                        <option value='SC'>Santa Catarina</option>
                        <option value='SP'>São Paulo</option>
                        <option value='SE'>Sergipe</option>
                        <option value='TO'>Tocantins</option>
                      </select>
                    </div>
                    {/*---------------------- FIM ESTADO ----------------------*/}
                  </div>
                  {/*---------------------- INICIO DESCRIPTION ----------------------*/}
                  <div className='row mb-3'>
                    <label className=' col-form-label fw-bold '>
                      {intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                    </label>
                    <div className='col-lg-12'>
                      <textarea
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        aria-multiline='true'
                        placeholder={intl.formatMessage({
                          id: 'COMMON.INPUT_DESCRIPTION_PLACEHOLDER',
                        })}
                        rows={4}
                        {...formik.getFieldProps('description')}
                      />
                    </div>
                    {formik.touched.description && formik.errors.description && (
                      <div className='fv-plugins-message-container text-danger'>
                        <div className='fv-help-block'>{formik.errors.description}</div>
                      </div>
                    )}
                  </div>
                  {/*---------------------- FIM DESCRIPTION ----------------------*/}

                  <div className='d-flex justify-content-end py-6'>
                    <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
                      {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                      {loading && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                    <button
                      type='reset'
                      onClick={resetInputs}
                      className='btn btn btn-sm btn-secondary mx-2'
                    >
                      {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
                    </button>
                  </div>
                </div>
                {/* ----------------------------------------------------------------------------------- */}

                <div className='col-lg-5'>
                  <MapEditEnterprise
                    name={'Novo'}
                    description={'Localização do empreendimento'}
                    setGeomPoint={setGeomPoint}
                    setGeomLine={setGeomLine}
                    setGeomPolygon={setGeomPolygon}
                    setTypeGeometry={setTypeGeometry}
                    geom_point={geom_point}
                    geom_line={geom_line}
                    geom_polygon={geom_polygon}
                    type_geometry={type_geometry}
                  />

                  <div className='d-flex justify-content-start '>
                    <button
                      type='button'
                      className='btn btn-sm btn-primary'
                      data-bs-toggle='modal'
                      data-bs-target='#kt_modal_1'
                    >
                      Adicionar vertices
                    </button>
                    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
                      <div className='modal-dialog'>
                        <div className='modal-content'>
                          <div className='modal-header'>
                            <h4 className='modal-title'>Inserir Geometria Através de Vertices</h4>
                            <div
                              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                              data-bs-dismiss='modal'
                              aria-label='Close'
                            >
                              <KTSVG
                                path='/media/icons/duotune/arrows/arr061.svg'
                                className='svg-icon svg-icon-2x'
                              />
                            </div>
                          </div>

                          <div className='modal-body'>
                            {/* INICIO HTML Tipo de Geometria */}
                            <div className='row mb-3'>
                              <label className='col-lg-5 col-form-label fw-bold '>
                                {/* <span>{intl.formatMessage({id: 'COMMON.INPUT_STATE'})}</span> */}
                                Tipo de Geometria
                              </label>

                              <div className='col-lg-7 fv-row'>
                                <select
                                  className='form-select form-select-solid form-select-lg fw-bold'
                                  {...formik.getFieldProps('type_geometry')}
                                >
                                  <option value='point' selected>
                                    Ponto
                                  </option>
                                  <option value='line' disabled>
                                    Linha
                                  </option>
                                  <option value='polygon' disabled>
                                    Polígono
                                  </option>
                                </select>
                              </div>
                            </div>

                            {/* FIM Tipo de Geometria */}

                            {/* INICIO HTML Coordenadas */}
                            <div className='row mb-3'>
                              <label className='col-lg-5 col-form-label fw-bold '>
                                {/* <span>{intl.formatMessage({id: 'COMMON.INPUT_STATE'})}</span> */}
                                Tipo de Coordenada
                              </label>

                              <div className='col-lg-7 fv-row'>
                                <select
                                  className='form-select form-select-solid form-select-lg fw-bold'
                                  {...formik.getFieldProps('type_coordinate')}
                                >
                                  <option value='projetada' selected>
                                    Projetada
                                  </option>
                                  <option value='lat_long'>Lat / Long</option>
                                </select>
                              </div>
                            </div>

                            {/* FIM Tipo de Geometria */}

                            {/* INICIO Latitude */}
                            <div className='row mb-3'>
                              <label className='col-lg-5 col-form-label fw-bold '>
                                {/* {intl.formatMessage({id: 'ENTERPRISES.INPUT_ACTIVE'})} */}
                                Latitude/N
                              </label>

                              <div className='col-lg-7'>
                                <div className='row'>
                                  <div className='col-lg-12 fv-row'>
                                    <input
                                      type='TEXT'
                                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                      placeholder={
                                        'Digite a Latitude'
                                        // intl.formatMessage({id: 'ENTERPRISES.INPUT_ACTIVE_PLACEHOLDER' })
                                      }
                                      {...formik.getFieldProps('latitude')}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* FIM Latitude */}

                            {/* INICIO Latitude */}
                            <div className='row mb-3'>
                              <label className='col-lg-5 col-form-label fw-bold '>
                                {/* {intl.formatMessage({id: 'ENTERPRISES.INPUT_ACTIVE'})} */}
                                Longitude/E
                              </label>

                              <div className='col-lg-7'>
                                <div className='row'>
                                  <div className='col-lg-12 fv-row'>
                                    <input
                                      type='TEXT'
                                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                      placeholder={
                                        'Digite a Longitude'
                                        // intl.formatMessage({id: 'ENTERPRISES.INPUT_ACTIVE_PLACEHOLDER' })
                                      }
                                      {...formik.getFieldProps('longitude')}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* FIM Latitude */}
                            {/* INICIO COMPRIMENTO */}
                            <div className='row mb-3'>
                              <label className='col-lg-12 col-form-label fw-bold '>
                                {intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                              </label>

                              <div className='col-lg-12'>
                                <div className='row'>
                                  <div className='col-lg-12 fv-row'>
                                    <textarea
                                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                      aria-multiline='true'
                                      disabled
                                      {...formik.getFieldProps('description')}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* FIM COMPRIMENTO */}
                          </div>

                          <div className='modal-footer' data-bs-dismiss='modal'>
                            <button
                              type='button'
                              className='btn btn-primary'
                              onClick={() => {
                                setLatitude(formik.getFieldProps('latitude').value)
                                setLongitude(formik.getFieldProps('longitude').value)
                              }}
                            >
                              Inserir Geometria
                            </button>

                            {/* <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                              Sair
                            </button> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <button className='btn btn-sm btn-primary  mx-2' type='button'>
                      Adicionar Sharefile
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormEnterprisesEdit}
